import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/styles';
import { Paper, IconButton, Slide, useScrollTrigger, Typography, Menu, MenuItem, Grid,Tooltip } from '@material-ui/core';
import { Print as PrintIcon, Room as RoomIcon, DateRange as DateRangeIcon, NavigateNext, NavigateBefore } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
    toolbar: {
        display: 'flex',
        width: '100%',
        boxSizing: 'border-box',
        zIndex: '1000',
        position: 'fixed',
        top: 56,
        left: 0,
        right: 0,
        [theme.breakpoints.up('lg')]: {
            left: 240,

        },
        [theme.breakpoints.up('sm')]: {
            top: 64
        }
    },
    period: {
        display: 'flex',
        alignItems: 'center',
    },
    row: {
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center',
      },
    font16: {
        fontSize: 16
    }

}));

const ToolbarForButton = props => {
    const { window, periodString, rooms, currentRoom, periods, currentPeriodFilter, prevBtnDis, nextBtnDis, onChangeRoom, onChangePeriod, onClickPrint, onClickNextPeriod, onClickPrevPeriod } = props;
    const classes = useStyles();
    const trigger = useScrollTrigger({ target: window ? window() : undefined });

    const [anchorMenuPeriod, setAnchorMenuPeriod] = useState(null);
    const [anchorMenuRoom, setAnchorMenuRoom] = useState(null);

    const roomName = useMemo(() => {
        const room = rooms.find(item => item.guid === currentRoom);
        if (room) { return room.name } else { return "" };
    }, [currentRoom, rooms]);

    const handleClickMenuPeriod = (event) => {
        setAnchorMenuPeriod(event.currentTarget);
    };

    const handleCloseMenuPeriod = () => {
        setAnchorMenuPeriod(null);
    };

    const handleMenuPeriodItemClick = (event, index) => {
        onChangePeriod(periods[index].id);
        setAnchorMenuPeriod(null);
    };

    const handleClickMenuRoom = (event) => {
        setAnchorMenuRoom(event.currentTarget);
    };

    const handleCloseMenuRoom = () => {
        setAnchorMenuRoom(null);
    };

    const handleMenuRoomItemClick = (event, index) => {
        onChangeRoom(rooms[index].guid);
        setAnchorMenuRoom(null);
    };

    return (
        <>
            <Slide appear={false} direction="down" in={!trigger}>

                <Paper variant="outlined" square className={classes.toolbar}>
                    <Grid container spacing={0}>
                        <Grid item md={4} xs={12}>
                            <Tooltip title="Печатная форма" placement="bottom">
                                <IconButton onClick={() => onClickPrint()}>
                                    <PrintIcon fontSize="large" />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Помещение(зал)" placement="bottom">
                                <IconButton aria-controls="MenuRoom" aria-haspopup="true" onClick={handleClickMenuRoom}>
                                    <RoomIcon fontSize="large" />
                                    <Typography className={classes.font16} noWrap>{roomName}</Typography>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Интервал" placement="bottom">
                                <IconButton aria-controls="MenuPeriod" aria-haspopup="true" onClick={handleClickMenuPeriod}>
                                    <DateRangeIcon fontSize="large" />
                                    <Typography className={classes.font16} noWrap>{periods.find(item => item.id === currentPeriodFilter).name}</Typography>
                                </IconButton>
                            </Tooltip>
                        </Grid>
                        <Grid item md={2} xs={12}>
                            <div className={classes.row}>
                                <div className={classes.period}>
                                    <IconButton disabled={prevBtnDis} onClick={() => onClickPrevPeriod()}>
                                        <NavigateBefore fontSize="large" />
                                    </IconButton>
                                    <Typography className={classes.font16} noWrap>{periodString}</Typography>
                                    <IconButton disabled={nextBtnDis} onClick={() => onClickNextPeriod()}>
                                        <NavigateNext fontSize="large" />
                                    </IconButton>
                                </div>
                            </div> 
                        </Grid>

                    </Grid>
                </Paper>
            </Slide>
            <Menu
                id="MenuPeriod"
                anchorEl={anchorMenuPeriod}
                keepMounted
                open={Boolean(anchorMenuPeriod)}
                onClose={handleCloseMenuPeriod}
            >
                {periods.map((period, index) => (
                    <MenuItem
                        key={period.id}
                        //disabled={index === 0}
                        selected={period.id === currentPeriodFilter}
                        onClick={(event) => handleMenuPeriodItemClick(event, index)}
                    >
                        {period.name}
                    </MenuItem>
                ))}
            </Menu>
            <Menu
                id="MenuRoom"
                anchorEl={anchorMenuRoom}
                keepMounted
                open={Boolean(anchorMenuRoom)}
                onClose={handleCloseMenuRoom}
                PaperProps={{
                    style: {
                        maxHeight: 60 * 4.5,
                        width: '20ch',
                    },
                }}
            >
                {rooms.map((room, index) => (
                    <MenuItem
                        key={room.guid}
                        //disabled={index === 0}
                        selected={room.guid === currentRoom}
                        onClick={(event) => handleMenuRoomItemClick(event, index)}
                    >
                        {room.name}
                    </MenuItem>
                ))}
            </Menu>
        </>

    );
}

ToolbarForButton.propTypes = {
    window: PropTypes.func,
    periods: PropTypes.array,
    periodString: PropTypes.string,
    currentPeriodFilter: PropTypes.string,
    onClickPrint: PropTypes.func,
    onChangePeriod: PropTypes.func,
    rooms: PropTypes.array,
    currentRoom: PropTypes.string,
    onChangeRoom: PropTypes.func,
    onClickNextPeriod: PropTypes.func,
    onClickPrevPeriod: PropTypes.func,
    prevBtnDis: PropTypes.bool,
    nextBtnDis: PropTypes.bool,
};

export default ToolbarForButton;